import asyncCaseCall from '../../../Action/CreateCase/createCase'
import { chatDetails } from '../../../App/App.config'
import pushGTMEvent from '../../../util/helper/pushGTMEvent'
import asynCMCall from './../../../Action/ChangeCM/changeContractManager'

const configContents = ({
  state: {
    credentials,
    langStrings,
    errorType,
    submitAgain,
    userSession,
    newCmDetails,
    currentCMDetails,
    caseDescription,
    error,
  },
  dispatch,
}) =>
  ({
    generalError: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.pageTitle2
          : "Request can't be completed",
        id: 'adsk-page-title',
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.responseText
          : 'Sorry, something went wrong while processing your request.',
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        isButton: true,
        id: 'adsk-submit-again',
        buttonTitle: langStrings
          ? langStrings.buttons.submitAgainButton
          : 'SUBMIT AGAIN',
        secondButtonId: 'adsk-contact-support',
        handleButtonClick: async () => {
          if (submitAgain.cmCall) {
            // submit again for CM Call.
            await asynCMCall(
              dispatch,
              userSession,
              newCmDetails,
              currentCMDetails,
              credentials,
            )
          } else {
            // submit again for case Call.
            await asyncCaseCall(
              dispatch,
              userSession,
              caseDescription,
              currentCMDetails,
              newCmDetails,
              error,
              credentials,
            )
          }
        },
        secondButtonTitle: langStrings
          ? langStrings.buttons.contactSupportButton
          : '<a href="" class="adsktm-show-contact-support-btn">CONTACT SUPPORT</a>',
        handleSecondButtonClick: () => {
          pushGTMEvent('ContactSupport')
          // expand Footer.
          document.querySelector('#adsktm-have-question-button').click()
        },
      },
    ],
    autoRenewCMError: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.cm.requestFailedScreen.autoRenewSubsTitle
          : 'Auto-renew subscription',
      },
      {
        description: langStrings
          ? langStrings.cm.requestFailedScreen.autoRenewSubs
          : 'Our records show that you have an auto-renewing subscription. To change the contract manager, you will have to cancel the subscription and start a new one.',
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.contactOptionsBelow
          : 'If you need help, <a id="go-to-contact-us" href="javascript:void(0);">contact us</a> using an option below.',
        paragraphStyle: { marginBottom: '20px' },
        handleTextClick: (e) => {
          // expand Footer.
          document.querySelector('#adsktm-have-question-button').click()
        },
      },
    ],
    expiredSubscription: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.expiredSubsTitle
          : 'Expired subscription',
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.expiredSubscription
          : `Your request can’t be completed because your subscription has expired. Please check with your account administrator or check your <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">account</a> for renewal options.`,
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.contactOptionsBelow
          : 'If you need help, <a id="go-to-contact-us" href="javascript:void(0);">contact us</a> using an option below.',
        paragraphStyle: { marginBottom: '20px' },
        handleTextClick: (e) => {
          // expand Footer.
          document.querySelector('#adsktm-have-question-button').click()
        },
      },
    ],
    apigeeError: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.pageTitle2
          : "Request can't be completed",
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.responseText
          : 'Sorry, something went wrong while processing your request.',
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        isButton: true,
        buttonTitle: langStrings
          ? langStrings.buttons.chatWithAgentButton
          : 'CHAT WITH AN AGENT',
        handleButtonClick: () =>
          window.liveagent.startChat(chatDetails.liveAgentId),
      },
    ],
  }[errorType])

const configFooter = ({ state: { langStrings }, dispatch }) => ({
  hasQuestion: true,
  hideBackButton: true,
  nextButtonContent: langStrings
    ? langStrings.buttons.restartButton
    : 'RESTART',
  handleNext: () => {
    dispatch({ type: 'RESTART_WIDGET' })
    window.location.reload(true)
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) =>
    dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleChatInitialized: () => dispatch({ type: 'AGENT_INITIALIZED' }),
  handleChatStarted: () => dispatch({ type: 'GO_TO_AGENT_AVAILABLE_PAGE' }),
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleNextButtonId: 'adsktm-cm-restart-button',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
})

export default {
  configContents,
  configFooter,
}
